import gql from "graphql-tag";

export const LIST_MASS_UPLOADS = gql`
  query listMassUploads {
    listMassUploads {
      massUploadId
      uploadedAt
      documentCount
      uploader {
        employee
        name
        rawName
        contract
        orgUnit
        jobClass
      }
      documents {
        _id
        filename
        size
        description
        user
      }
    }
  }
`;
